import get from 'lodash/get'
import { Collation } from 'common/models/typings/Collation'

export const getTotalStops = (collations: Array<Collation>) =>
  collations.filter((collation) =>
    (get(collation, 'shipmentIds', []) as number[]).some(
      (shipmentId) => shipmentId > -1,
    ),
  ).length
